export default __webpack_public_path__ + "static/media/keyboard_arrow_down-black-18dp.89aeb2d4.svg";